import { gameSagas } from '@/features/gameSession';
import { sharedSagas } from '@/shared/app';
import { playButtonSagas } from '@/shared/modules/playButton';

const rootSaga = () => {
	return [gameSagas, playButtonSagas, sharedSagas];
};

export default rootSaga;
